import script from "./message-revoked.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-revoked.vue?vue&type=script&lang=ts&setup=true"

import "./message-revoked.vue?vue&type=style&index=0&id=cd3867c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd3867c8"]])

export default __exports__